import type { RouteObject } from 'react-router-dom';
import Layout from '@/pages/Layout';
import Home from '@/pages/home/page';
import CategoryPage from '@/pages/category/page';
import ArticlePage from '@/pages/article/page';
import AboutPage from '@/pages/about/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/category/:slug',
        element: <CategoryPage />,
      },
      {
        path: '/article/:slug',
        element: <ArticlePage />,
      },
      {
        path: '/about',
        element: <AboutPage />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default routes;